import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { PrivateRoutes } from "./HomeRoutes";

const { PUBLIC_URL } = process.env;

const AppRoutes = () => {
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <>
          <Route path="/*" element={<PrivateRoutes />} />
          <Route index element={<Navigate to="/home" />} />
        </>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
